import { Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

import { emailLogColumns } from "./email-log-grid-columns";
import { UserPermissionName } from "../../../models/user-permission-name";
import { SiTrackGrid } from "../../../components/si-track-grid/si-track-grid";
import { planReviewApiKeyStore } from "../../../api/plan-review-api-key-store";

const styling = {
    dialogTitleStyle: { padding: '16px 24px 0' },
    contentPadding: { paddingTop: '30px' },
};

interface EmailLogDialog {
    planReviewData: any;
    onClosed: () => void;
}
export const EmailLogDialog = ({ planReviewData, onClosed }: EmailLogDialog) => {
    return (
        <Dialog
            open={true}
            fullWidth={true}
            maxWidth={'lg'}
            // onClose={handleClose}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            <DialogTitle id="dialog-title" style={styling.dialogTitleStyle}>
                Email Log
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClosed}
                sx={{
                    position: 'absolute',
                    right: 10,
                    top: 9,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <Tooltip title={<Typography variant="body1">Close</Typography>}>
                    <CloseIcon />
                </Tooltip>
            </IconButton>
            <DialogContent dividers style={styling.contentPadding} className="popupDilog">
                <Grid container spacing={2}>
                    <Grid item lg={12} sm={12} xl={12} xs={12}>
                        <SiTrackGrid
                            fileTitle='email_log'
                            dataItemKey="mailLogID"
                            columns={emailLogColumns}
                            queryConfig={planReviewApiKeyStore.getEmailLogs(planReviewData?.planReviewTaskID)}
                            actionPermissions={{
                                export: UserPermissionName.DOWNLOAD_GRID,
                            }}
                        />
                    </Grid>
                    <Grid item lg={12} sm={12} xl={12} xs={12}>
                        <Grid
                            container
                            direction="row"
                            sx={{
                                justifyContent: "flex-end",
                                alignItems: "flex-start",
                            }}
                        >
                            <Button variant="outlined" style={{ width: '130px' }} onClick={onClosed}>
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}